import { Language } from './language';

export class Languages {
    static get ENGLISH_US(): Language { return new Language('LANGUAGES.ENGLISH', 'us', 'en-US', 'en'); }
    static get PORTUGUESE_BR(): Language { return new Language('LANGUAGES.PORTUGUESE', 'br', 'pt-BR', 'pt'); }
    static get SPANISH_ES(): Language { return new Language('LANGUAGES.SPANISH', 'es', 'es', 'es'); }
}
